<template>
  <button class="custom-mobile-button" @click="back">
    {{ $t("Confirmation.Cancel") }}
  </button>
</template>
<script>
export default {
  name: "BackButton",
  methods: {
    back(event) {
      event.preventDefault();
      this.$router.go(-1);
    },
  },
};
</script>
